/**
 * [2026-06-10 단계2] 이 빌드(디자인 폴더)의 '틀' 디자인 템플릿 ID — 폴백 전용
 *
 * ⚠ [2026-08-25] 이 값은 더 이상 게임사 이미지(로고·캐릭터)의 디자인을 결정하지 않는다.
 *      유저 API(providers)가 요청마다 '접속 주소에 배정된 디자인'(회원관리 배정)을 판정해 그것을 우선한다.
 *      WHY: "디자인 추가"(틀 공유)로 만든 디자인을 사이트에 배정하면, 이 상수(틀 번호)로는 그 디자인에
 *           올린 로고·캐릭터를 절대 받을 수 없었다(2026-08-25 lime Asia Gaming Slot 실사고). 디자인은
 *           계속 추가·제거되므로 빌드 상수가 아니라 서버 판정을 따른다. 이 값은 미등록 주소(직접 포트
 *           접근 등)로 들어왔을 때만 쓰인다. 서버 규칙: user-api services/siteDesignResolver.js
 *      빌드 시 REACT_APP_DESIGN_TEMPLATE_ID 환경변수로 재정의 가능. 비어 있으면 template_id 를 보내지 않는다.
 */
const DESIGN_TEMPLATE_ID = process.env.REACT_APP_DESIGN_TEMPLATE_ID || '6';

export default DESIGN_TEMPLATE_ID;
